import { getCookie, getCookieAmend, setCookie } from './cookie';
import { currentTime, time, getQueryVariable, filterVChannelId } from './util';
import axios from 'axios'; // 引入axios
import wetvKernel from '@tencent/wetv-kernel';
const { ageisReportor } = wetvKernel;

function report(data, iSstartUp) {
  const userInfo = getUserInfo();
  const uaInfo = getUAInfo();
  const baseInfo = getBaseInfo();
  const extraReportInfo = getExtraInfo();
  const reportData = {
    ...userInfo,
    ...uaInfo,
    ...baseInfo,
    ...extraReportInfo,
    ...data,
  };
  if (iSstartUp) {
    const now = new Date().getTime(); // 获取当前时间时间戳
    setCookie('StartTime', now);
  }
  sendRequest(reportData);
}

// 错误日志上传方法储存
function errorLogReport(data) {
  const guid = getCookieAmend('guid') || '';
  const vuid = getCookieAmend('vuserid') || '';
  const uin = vuid ? `${guid}-${vuid}` : `${guid}`;
  const params = `params=${JSON.stringify(data.params)}&data=${data.data}&softwareInfo=${process.env.REACT_APP_SOFTWARE_INFO}&uin=${uin}`;
  ageisReportor && ageisReportor.reportEvent({
    name: 'apiError', // 埋点名称
    ext1: `reqUrl=${data.path}`, // 触发动作
    ext3: `${params}&errCode=${data.err_code}&errMsg=${data.err_msg}&content=${data.content}`,
  });
  const { offlineLog } = wetvKernel;
  // 获取日志收集器
  const logger = offlineLog.logger('fetcher');
  try {
    logger.error(JSON.stringify(data));
  } catch(e) {
    logger.error('[offlineLog.logger Log serialization failed');
  }
  let records = [];
  // 若已存在错误日志则新增
  if (getCookie('errorLog') !== null) {
    records = getCookie('errorLog');
    records.push(data);
    setCookie('errorLog', records); // 存储历史
  } else {
    // 若不存在错误日志则创建新的日志
    records = [];
    records.push(data);
    setCookie('errorLog', records); // 存储历史
  }
}

function sendRequest(params) {
  const paramStr = convertQueryToString(params);
  const url = `//htrace.wetvinfo.com/kv?attaid=${params.attaId
  }&token=1658661919&_dc=${Math.random()}`;
  if (paramStr.length + url.length < 2803) {
    // 参数过长时，需改用post请求
    const attaImg = new Image(1, 1);
    attaImg.src = `${url}${paramStr}`;
  } else {
    axios.post(url, params);
  }
}

function getUAInfo() {
  let network = '';
  if (navigator.connection) {
    if (navigator.connection.effectiveType) {
      network = navigator.connection.effectiveType;
    } else {
      network = 'unknown';
    }
  } else {
    network = 'unknown';
  }
  network = {
    unknown: 0,
    wifi: 1,
    '2g': 2,
    '3g': 3,
    '4g': 4,
  }[network] || 0;
  return {
    ua: window.navigator.userAgent,
    network,
    refer_url: window.document.referrer,
    platform: getCookieAmend('vplatform'),
    qimei36: '',
  };
}

function getUserInfo() {
  const { langInfo = {} } = window;
  return {
    sIp: langInfo.ipString || '',
    uuid: getCookieAmend('guid'),
    countrycode: getCookieAmend('country_code'),
    vuserid: getCookieAmend('vuserid') ? getCookieAmend('vuserid') : '',
    isvip: getCookieAmend('status') === '3' ? 1 : 0,
  };
}

function getBaseInfo() {
  let prodLine = '';
  let vchannelId = '';
  if (getQueryVariable('prod_line')) {
    prodLine = getQueryVariable('prod_line');
    localStorage.setItem('prod_line', prodLine);
  } else {
    if (localStorage.getItem('prod_line')) {
      prodLine = localStorage.getItem('prod_line');
    } else {
      prodLine = '';
    }
  }
  if (getQueryVariable('v_channel_id')) {
    vchannelId = getQueryVariable('v_channel_id');
    localStorage.setItem('v_channel_id', filterVChannelId(vchannelId));
  } else {
    if (localStorage.getItem('v_channel_id')) {
      vchannelId = localStorage.getItem('v_channel_id');
    } else {
      vchannelId = '';
    }
  }
  return {
    imp_date: time(),
    ctime: currentTime(),
    app_type: 'linuxTV',
    ref_page: getCookie('ref_page') ? getCookie('ref_page') : '',
    page_id: getCookie('page_id') ? getCookie('page_id') : '',
    lm_experiment_id: '',
    prod_line: prodLine,
    v_channel_id: vchannelId,
  };
}

function getExtraInfo() {
  const utmSource = window.sessionStorage.getItem('utm_source');
  const utmMedium = window.sessionStorage.getItem('utm_medium');
  const utmCampaign = window.sessionStorage.getItem('utm_campaign');
  return {
    extend_column: JSON.stringify({
      utm_source: utmSource || '',
      utm_medium: utmMedium || '',
      utm_campaign: utmCampaign || '',
    }),
  };
}

function convertQueryToString(
  query,
  options = {
    useEncode: '',
    strictMode: '',
  },
) {
  const handleVal = (key, val, options) => {
    let str = '';
    if (isObject(val)) {
      Object.keys(val).forEach((objKey) => {
        str += handleVal(objKey, val[objKey], options);
      });
    } else if (Array.isArray(val)) {
      val.forEach((arrVal, i) => {
        str += handleVal(`${key}[${i}]`, arrVal, options);
      });
    } else {
      const { useEncode = true, strictMode = true } = options;
      if (strictMode && val === '') {
        // 严格模式下 空字符串检查
        return '';
      }
      const finalKey = key === '' ? '' : `${key}=`;
      const finalVal = useEncode ? encodeURIComponent(val) : val;
      str = `${finalKey}${finalVal}&`;
    }
    return str;
  };

  const str = handleVal('', query, options);
  return str.substr(0, Math.max(0, str.length - 1));
}
function isObject(val) {
  return val !== null && typeof val === 'object' && Array.isArray(val) === false;
}
export { report, errorLogReport, sendRequest, getUAInfo, getUserInfo, getBaseInfo, convertQueryToString, isObject };
